module.exports = __webpack_public_path__ + "img/img28.9e90f95e.svg";